module.exports = __webpack_public_path__ + "r-v3/img/sticker_12.6649205c.svg";